(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-tile-designer"] && !Shopify.designMode) return;
  try {
    
(function(){var W=1500,H=1500;
function init(s){if(!s||s.dataset.ready)return;s.dataset.ready='1';var c=s.querySelector('[data-canvas]'),x=c&&c.getContext('2d');if(!x)return;
var f=s.querySelector('form'),pi=s.querySelector('[data-photo]'),z=s.querySelector('[data-zoom]'),fit=s.querySelector('[data-fit]'),eff=s.querySelector('[data-effect]'),txt=s.querySelector('[data-text]'),font=s.querySelector('[data-font]'),tc=s.querySelector('[data-textcolor]'),sz=s.querySelector('[data-size]'),yy=s.querySelector('[data-y]'),bd=s.querySelector('[data-border]'),bc=s.querySelector('[data-bordercolor]'),bg=s.querySelector('[data-bgcolor]'),pf=s.querySelector('[data-print]'),pt=s.querySelector('[data-ptext]'),pfont=s.querySelector('[data-pfont]'),pd=s.querySelector('[data-pdata]'),er=s.querySelector('[data-err]'),buy=s.querySelector('[data-buy]');
var im=null,url=null,st={bg:'#fff',border:75,bc:'#fff',fit:'cover',zoom:1,ox:0,oy:0,rot:0,eff:'none',text:'',font:'Arial',tc:'#30302b',size:95,y:78};
function filt(){return st.eff==='grayscale'?'grayscale(1)':st.eff==='sepia'?'sepia(.55)':st.eff==='contrast'?'contrast(1.22) saturate(1.08)':'none'}
function scale(){if(!im)return 1;var r=Math.abs(st.rot%180)===90,iw=r?im.naturalHeight:im.naturalWidth,ih=r?im.naturalWidth:im.naturalHeight;return(st.fit==='contain'?Math.min(W/iw,H/ih):Math.max(W/iw,H/ih))*st.zoom}
function lines(t,m){var a=[];String(t||'').split(/\n/).forEach(function(p){var w=p.trim().split(/\s+/).filter(Boolean);if(!w.length){a.push('');return}var l=w.shift();w.forEach(function(q){var n=l+' '+q;if(x.measureText(n).width<=m)l=n;else{a.push(l);l=q}});a.push(l)});return a.slice(0,4)}
function draw(){x.clearRect(0,0,W,H);x.fillStyle=st.bg;x.fillRect(0,0,W,H);if(im){var sc=scale();x.save();x.translate(W/2+st.ox,H/2+st.oy);x.rotate(st.rot*Math.PI/180);x.filter=filt();x.drawImage(im,-im.naturalWidth*sc/2,-im.naturalHeight*sc/2,im.naturalWidth*sc,im.naturalHeight*sc);x.restore()}if(st.border){x.save();x.strokeStyle=st.bc;x.lineWidth=st.border*2;x.strokeRect(0,0,W,H);x.restore()}if(st.text.trim()){x.save();x.textAlign='center';x.textBaseline='middle';x.fillStyle=st.tc;x.font='700 '+st.size+'px "'+st.font+'"';var ls=lines(st.text,W-220),lh=st.size*1.18,sy=H*(st.y/100)-((ls.length-1)*lh)/2;ls.forEach(function(l,i){x.fillText(l,W/2,sy+i*lh)});x.restore()}}
function sync(){st.zoom=+(z.value||100)/100;st.fit=fit.value;st.eff=eff.value;st.text=txt.value;st.font=font.value;st.tc=tc.value;st.size=+sz.value;st.y=+yy.value;st.border=+bd.value;st.bc=bc.value;st.bg=bg.value;draw()}
pi&&pi.addEventListener('change',function(){var file=pi.files&&pi.files[0];if(!file)return;if(url)URL.revokeObjectURL(url);url=URL.createObjectURL(file);var a=new Image();a.onload=function(){im=a;st.ox=st.oy=0;st.zoom=1;z.value='100';draw()};a.src=url});
[z,fit,eff,txt,font,tc,sz,yy,bd,bc,bg].forEach(function(e){e&&e.addEventListener('input',sync)});
s.querySelectorAll('[data-bg]').forEach(function(b){b.addEventListener('click',function(){st.bg=b.dataset.bg;bg.value=st.bg;draw()})});
s.querySelector('[data-rotate]').addEventListener('click',function(){st.rot=(st.rot+90)%360;st.ox=st.oy=0;draw()});s.querySelector('[data-center]').addEventListener('click',function(){st.ox=st.oy=0;draw()});
s.querySelectorAll('[data-preset]').forEach(function(b){b.addEventListener('click',function(){var p=b.dataset.preset;if(p==='full'){st.fit='cover';st.border=0;st.eff='none'}if(p==='border'){st.fit='cover';st.border=75;st.bc='#fff';st.eff='none'}if(p==='bw'){st.eff='grayscale';st.border=75;st.bc='#fff'}fit.value=st.fit;bd.value=st.border;bc.value=st.bc;eff.value=st.eff;draw()})});
s.querySelector('[data-reset]').addEventListener('click',function(){location.reload()});
var drag=0,lx=0,ly=0;c.addEventListener('pointerdown',function(e){if(!im)return;drag=1;lx=e.clientX;ly=e.clientY});c.addEventListener('pointermove',function(e){if(!drag||!im)return;var k=W/c.getBoundingClientRect().width;st.ox+=(e.clientX-lx)*k;st.oy+=(e.clientY-ly)*k;lx=e.clientX;ly=e.clientY;draw()});['pointerup','pointercancel','pointerleave'].forEach(function(n){c.addEventListener(n,function(){drag=0})});
f&&f.addEventListener('submit',function(e){if(!buy)return;if(!im&&!st.text.trim()){e.preventDefault();er.hidden=false;er.textContent='Upload een foto of voeg tekst toe.';return}if(f.dataset.rendered)return;e.preventDefault();buy.disabled=true;buy.textContent='Ontwerp voorbereiden…';c.toBlob(function(blob){if(!blob){buy.disabled=false;return}var file=new File([blob],'fototegel-'+Date.now()+'.png',{type:'image/png'}),dt=new DataTransfer();dt.items.add(file);pf.files=dt.files;pt.value=st.text.trim()||'Geen tekst';pfont.value=st.font;pd.value=JSON.stringify(st);f.dataset.rendered='1';f.submit()},'image/png')});draw()}
function boot(r){(r||document).querySelectorAll('[data-tile]').forEach(init)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document)});else boot(document);document.addEventListener('shopify:section:load',function(e){boot(e.target)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-tile-editor"]) return;
  try {
    
(function(){
  function init(){
    var root=document.querySelector('[data-zt-tile-entry]');
    if(!root || root.dataset.ready==='1') return;

    var form=document.querySelector('.studio-pdp-form');
    if(!form) return;

    root.dataset.ready='1';
    root.hidden=false;

    var launcher=root.querySelector('[data-zt-launcher]');
    var quantity=form.querySelector('.studio-pdp-quantity-label');
    if(quantity) form.insertBefore(launcher,quantity);
    else form.insertBefore(launcher,form.firstChild);

    var dialog=root.querySelector('[data-zt-dialog]');
    document.body.appendChild(dialog);

    var canvas=dialog.querySelector('[data-zt-canvas]');
    var ctx=canvas.getContext('2d');
    var photoInput=dialog.querySelector('[data-zt-photo]');
    var directPhotoInput=root.querySelector('[data-zt-photo-direct]');
    var directUploadButton=root.querySelector('[data-zt-upload-direct]');
    var photoTrigger=dialog.querySelector('[data-zt-photo-trigger]');
    var zoomInput=dialog.querySelector('[data-zt-zoom]');
    var textInput=dialog.querySelector('[data-zt-text]');
    var fontSelect=dialog.querySelector('[data-zt-font]');
    var textColor=dialog.querySelector('[data-zt-text-color]');
    var textSize=dialog.querySelector('[data-zt-text-size]');
    var note=dialog.querySelector('[data-zt-note]');
    var message=dialog.querySelector('[data-zt-message]');
    var savedBox=launcher.querySelector('[data-zt-saved]');
    var thumb=launcher.querySelector('[data-zt-thumb]');
    var addButton=form.querySelector('[data-add-to-cart]');
    var size=Number(root.dataset.ztPx || 1299);
    var tileLabel=root.dataset.ztSize || '11 × 11 cm';
    var tileCode=root.dataset.ztCode || '11x11';
    var scaleFactor=size/1299;
    var minPhotoPx=tileCode==='15x15' ? 1400 : 1000;
    var history=[];
    var saved=false;

    var state={
      image:null,
      zoom:1,
      photoX:0,
      photoY:0,
      text:'',
      font:'Arial',
      fontLabel:'Strak',
      textColor:'#2f302b',
      textSize:Math.round(88*scaleFactor),
      textX:size/2,
      textY:size*.82,
      bg:'#ffffff',
      border:'',
      illustration:'',
      illustrationX:size*.76,
      illustrationY:size*.22,
      moveMode:'photo'
    };

    textSize.min=String(Math.round(42*scaleFactor));
    textSize.max=String(Math.round(180*scaleFactor));
    textSize.value=String(state.textSize);

    function snapshot(){
      return {
        zoom:state.zoom,
        photoX:state.photoX,
        photoY:state.photoY,
        text:state.text,
        font:state.font,
        fontLabel:state.fontLabel,
        textColor:state.textColor,
        textSize:state.textSize,
        textX:state.textX,
        textY:state.textY,
        bg:state.bg,
        border:state.border,
        illustration:state.illustration,
        illustrationX:state.illustrationX,
        illustrationY:state.illustrationY,
        moveMode:state.moveMode
      };
    }

    function pushHistory(){
      history.push(snapshot());
      if(history.length>30) history.shift();
    }

    function restore(s){
      if(!s) return;
      Object.keys(s).forEach(function(k){ state[k]=s[k]; });
      textInput.value=state.text;
      zoomInput.value=Math.round(state.zoom*100);
      fontSelect.value=state.font;
      textColor.value=state.textColor;
      textSize.value=state.textSize;
      syncChoices();
      draw();
    }

    function syncChoices(){
      dialog.querySelectorAll('[data-zt-bg] button').forEach(function(b){
        b.classList.toggle('is-active',b.dataset.color===state.bg);
      });
      dialog.querySelectorAll('[data-zt-border]').forEach(function(b){
        b.classList.toggle('is-active',(b.dataset.ztBorder||'')===state.border);
      });
      dialog.querySelectorAll('[data-zt-move]').forEach(function(b){
        b.classList.toggle('is-active',b.dataset.ztMove===state.moveMode);
      });
      dialog.querySelectorAll('[data-zt-illustration]').forEach(function(b){
        b.classList.toggle('is-active',(b.dataset.ztIllustration||'')===state.illustration);
      });
    }

    function wrapText(text,x,y,maxWidth,lineHeight){
      var words=text.trim().split(/\s+/);
      var lines=[];
      var line='';
      words.forEach(function(word){
        var test=line ? line+' '+word : word;
        if(line && ctx.measureText(test).width>maxWidth){
          lines.push(line);
          line=word;
        } else {
          line=test;
        }
      });
      if(line) lines.push(line);
      var start=y-((lines.length-1)*lineHeight/2);
      lines.forEach(function(l,i){ctx.fillText(l,x,start+i*lineHeight);});
    }

    function drawIllustration(){
      if(!state.illustration) return;
      var s=size*.105;
      ctx.save();
      ctx.translate(state.illustrationX,state.illustrationY);
      ctx.lineWidth=Math.max(5,size*.005);
      ctx.lineCap='round';
      ctx.lineJoin='round';
      ctx.strokeStyle='#bf7864';
      ctx.fillStyle='#f2ddd5';

      if(state.illustration==='heart'){
        ctx.beginPath();
        ctx.moveTo(0,s*.55);
        ctx.bezierCurveTo(-s*.95,-s*.05,-s*.72,-s*.85,0,-s*.42);
        ctx.bezierCurveTo(s*.72,-s*.85,s*.95,-s*.05,0,s*.55);
        ctx.stroke();
      }

      if(state.illustration==='rainbow'){
        var colors=['#bf7864','#d7b56d','#87947d'];
        colors.forEach(function(color,i){
          ctx.beginPath();
          ctx.strokeStyle=color;
          ctx.lineWidth=Math.max(8,size*.009);
          ctx.arc(0,s*.32,s*(.95-i*.24),Math.PI,0,false);
          ctx.stroke();
        });
      }

      if(state.illustration==='bunny'){
        ctx.strokeStyle='#a77762';
        ctx.fillStyle='#ead6c8';
        ctx.beginPath();
        ctx.ellipse(-s*.28,-s*.65,s*.22,s*.55,-.18,0,Math.PI*2);
        ctx.ellipse(s*.28,-s*.65,s*.22,s*.55,.18,0,Math.PI*2);
        ctx.fill();
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(0,0,s*.62,0,Math.PI*2);
        ctx.fill();
        ctx.stroke();
        ctx.fillStyle='#4d443f';
        ctx.beginPath();
        ctx.arc(-s*.2,-s*.08,s*.045,0,Math.PI*2);
        ctx.arc(s*.2,-s*.08,s*.045,0,Math.PI*2);
        ctx.fill();
        ctx.beginPath();
        ctx.arc(0,s*.12,s*.055,0,Math.PI*2);
        ctx.fill();
      }
      ctx.restore();
    }

    function draw(){
      ctx.clearRect(0,0,size,size);
      ctx.fillStyle=state.bg;
      ctx.fillRect(0,0,size,size);

      if(state.image){
        var base=Math.max(size/state.image.naturalWidth,size/state.image.naturalHeight);
        var scale=base*state.zoom;
        var w=state.image.naturalWidth*scale;
        var h=state.image.naturalHeight*scale;
        var x=(size-w)/2+state.photoX;
        var y=(size-h)/2+state.photoY;
        ctx.save();
        ctx.beginPath();
        ctx.rect(0,0,size,size);
        ctx.clip();
        ctx.drawImage(state.image,x,y,w,h);
        ctx.restore();
      }

      drawIllustration();

      if(state.text.trim()){
        ctx.save();
        ctx.textAlign='center';
        ctx.textBaseline='middle';
        ctx.fillStyle=state.textColor;
        ctx.font='600 '+state.textSize+'px "'+state.font+'"';
        wrapText(state.text,state.textX,state.textY,size*.82,state.textSize*1.16);
        ctx.restore();
      }

      if(state.border){
        ctx.save();
        ctx.strokeStyle=state.border;
        ctx.lineWidth=28;
        ctx.strokeRect(14,14,size-28,size-28);
        ctx.restore();
      }
    }

    function setMessage(text,type){
      message.textContent=text;
      message.classList.remove('is-error','is-warning');
      if(type) message.classList.add(type);
    }

    function openEditor(){
      if(typeof dialog.showModal==='function') dialog.showModal();
      else dialog.setAttribute('open','');
      document.body.classList.add('zt-tile-open');
      draw();
    }

    function closeEditor(){
      if(dialog.open && typeof dialog.close==='function') dialog.close();
      else dialog.removeAttribute('open');
      document.body.classList.remove('zt-tile-open');
    }

    function ensureHidden(name,value){
      var input=form.querySelector('[data-zt-property="'+name+'"]');
      if(!input){
        input=document.createElement('input');
        input.type='hidden';
        input.name='properties['+name+']';
        input.dataset.ztProperty=name;
        form.appendChild(input);
      }
      input.value=value;
      return input;
    }

    function ensureFileField(){
      var field=form.querySelector('[data-zt-design-file]');
      if(!field){
        field=document.createElement('input');
        field.type='file';
        field.name='properties[Ontwerpbestand]';
        field.accept='image/png';
        field.hidden=true;
        field.dataset.ztDesignFile='1';
        form.appendChild(field);
      }
      form.enctype='multipart/form-data';
      return field;
    }

    function markUnsaved(){
      saved=false;
      if(addButton) addButton.disabled=true;
      savedBox.hidden=true;
    }

    function saveDesign(){
      if(!state.image && !state.text.trim() && !state.illustration){
        setMessage('Voeg eerst een foto en/of tekst toe aan je tegel.','is-error');
        return;
      }

      ensureHidden('Personalisatie','Eigen ontwerp');
      ensureHidden('Formaat',tileLabel);
      ensureHidden('Tekst',state.text.trim() || 'Geen tekst');
      ensureHidden('Lettertype',state.text.trim() ? state.fontLabel : 'Niet van toepassing');
      ensureHidden('Achtergrond',state.bg);
      ensureHidden('Rand',state.border || 'Geen');
      ensureHidden('Illustratie',state.illustration || 'Geen');
      ensureHidden('Ontwerp instellingen',JSON.stringify({
        formaat:tileCode,
        zoom:Math.round(state.zoom*100),
        photoX:Math.round(state.photoX),
        photoY:Math.round(state.photoY),
        textX:Math.round(state.textX),
        textY:Math.round(state.textY),
        textSize:state.textSize,
        illustration:state.illustration,
        illustrationX:Math.round(state.illustrationX),
        illustrationY:Math.round(state.illustrationY)
      }));

      canvas.toBlob(function(blob){
        try{
          var file=new File([blob],'fototegel-'+tileCode+'.png',{type:'image/png'});
          var transfer=new DataTransfer();
          transfer.items.add(file);
          ensureFileField().files=transfer.files;

          thumb.src=canvas.toDataURL('image/jpeg',.82);
          savedBox.hidden=false;
          saved=true;
          if(addButton) addButton.disabled=false;
          setMessage('Ontwerp opgeslagen. Je kunt het nu toevoegen aan je winkelwagen.','');
          closeEditor();
        }catch(e){
          setMessage('Het ontwerp kon niet worden opgeslagen. Probeer het opnieuw.','is-error');
        }
      },'image/png');
    }

    root.querySelector('[data-zt-open]').addEventListener('click',openEditor);
    if(photoTrigger) photoTrigger.addEventListener('click',function(){photoInput.click();});
    if(directUploadButton && directPhotoInput){
      directUploadButton.addEventListener('click',function(){directPhotoInput.click();});
    }
    root.querySelector('[data-zt-edit]').addEventListener('click',openEditor);
    dialog.querySelector('[data-zt-close]').addEventListener('click',closeEditor);
    dialog.querySelectorAll('[data-zt-done]').forEach(function(b){b.addEventListener('click',saveDesign);});

    dialog.addEventListener('cancel',function(){
      document.body.classList.remove('zt-tile-open');
    });

    dialog.querySelectorAll('[data-zt-tab]').forEach(function(button){
      button.addEventListener('click',function(){
        dialog.querySelectorAll('[data-zt-tab]').forEach(function(b){b.classList.remove('is-active');});
        dialog.querySelectorAll('[data-zt-panel]').forEach(function(p){p.classList.remove('is-active');});
        button.classList.add('is-active');
        dialog.querySelector('[data-zt-panel="'+button.dataset.ztTab+'"]').classList.add('is-active');
      });
    });

    dialog.querySelector('[data-zt-undo]').addEventListener('click',function(){
      restore(history.pop());
      markUnsaved();
    });

    function loadPhotoFile(file,openAfter){
      if(!file) return;
      pushHistory();
      var reader=new FileReader();
      reader.onload=function(event){
        var img=new Image();
        img.onload=function(){
          state.image=img;
          state.photoX=0;
          state.photoY=0;
          state.zoom=1;
          zoomInput.value='100';
          markUnsaved();
          if(img.naturalWidth<minPhotoPx || img.naturalHeight<minPhotoPx){
            note.textContent='Deze foto kan wat minder scherp afdrukken.';
            setMessage('Voor het mooiste resultaat adviseren we voor '+tileLabel+' een foto van minimaal circa '+minPhotoPx+' × '+minPhotoPx+' pixels.','is-warning');
          }else{
            note.textContent='Foto geladen — sleep om de uitsnede te bepalen.';
            setMessage('Foto geladen. Sleep om de uitsnede te bepalen en voeg eventueel tekst toe.','');
          }
          draw();
          if(openAfter) openEditor();
        };
        img.src=event.target.result;
      };
      reader.readAsDataURL(file);
    }

    photoInput.addEventListener('change',function(){
      loadPhotoFile(photoInput.files && photoInput.files[0],false);
    });

    if(directPhotoInput){
      directPhotoInput.addEventListener('change',function(){
        loadPhotoFile(directPhotoInput.files && directPhotoInput.files[0],true);
      });
    }

    zoomInput.addEventListener('change',pushHistory);
    zoomInput.addEventListener('input',function(){
      state.zoom=Number(zoomInput.value)/100;
      markUnsaved();
      draw();
    });

    dialog.querySelector('[data-zt-reset-photo]').addEventListener('click',function(){
      pushHistory();
      state.photoX=0;
      state.photoY=0;
      state.zoom=1;
      zoomInput.value='100';
      markUnsaved();
      draw();
    });

    textInput.addEventListener('focus',pushHistory);
    textInput.addEventListener('input',function(){
      state.text=textInput.value;
      markUnsaved();
      draw();
    });

    fontSelect.addEventListener('change',function(){
      pushHistory();
      state.font=fontSelect.value;
      state.fontLabel=fontSelect.options[fontSelect.selectedIndex].dataset.label || fontSelect.options[fontSelect.selectedIndex].text;
      markUnsaved();
      draw();
    });

    textColor.addEventListener('change',pushHistory);
    textColor.addEventListener('input',function(){
      state.textColor=textColor.value;
      markUnsaved();
      draw();
    });

    textSize.addEventListener('change',pushHistory);
    textSize.addEventListener('input',function(){
      state.textSize=Number(textSize.value);
      markUnsaved();
      draw();
    });

    dialog.querySelectorAll('[data-zt-bg] button').forEach(function(button){
      button.addEventListener('click',function(){
        pushHistory();
        state.bg=button.dataset.color;
        syncChoices();
        markUnsaved();
        draw();
      });
    });

    dialog.querySelectorAll('[data-zt-border]').forEach(function(button){
      button.addEventListener('click',function(){
        pushHistory();
        state.border=button.dataset.ztBorder || '';
        syncChoices();
        markUnsaved();
        draw();
      });
    });

    dialog.querySelectorAll('[data-zt-illustration]').forEach(function(button){
      button.addEventListener('click',function(){
        pushHistory();
        state.illustration=button.dataset.ztIllustration || '';
        state.moveMode=state.illustration ? 'illustration' : 'photo';
        markUnsaved();
        syncChoices();
        draw();
      });
    });

    dialog.querySelectorAll('[data-zt-move]').forEach(function(button){
      button.addEventListener('click',function(){
        state.moveMode=button.dataset.ztMove;
        syncChoices();
      });
    });

    var dragging=false,lastX=0,lastY=0,moved=false;

    function getPoint(event){
      var r=canvas.getBoundingClientRect();
      return {
        x:(event.clientX-r.left)*(size/r.width),
        y:(event.clientY-r.top)*(size/r.height)
      };
    }

    canvas.addEventListener('pointerdown',function(event){
      pushHistory();
      dragging=true;
      moved=false;
      var p=getPoint(event);
      lastX=p.x;
      lastY=p.y;
      if(canvas.setPointerCapture) canvas.setPointerCapture(event.pointerId);
    });

    canvas.addEventListener('pointermove',function(event){
      if(!dragging) return;
      event.preventDefault();
      var p=getPoint(event);
      var dx=p.x-lastX;
      var dy=p.y-lastY;
      lastX=p.x;
      lastY=p.y;

      if(state.moveMode==='text' && state.text.trim()){
        state.textX=Math.max(0,Math.min(size,state.textX+dx));
        state.textY=Math.max(0,Math.min(size,state.textY+dy));
        moved=true;
      }else if(state.moveMode==='illustration' && state.illustration){
        state.illustrationX=Math.max(0,Math.min(size,state.illustrationX+dx));
        state.illustrationY=Math.max(0,Math.min(size,state.illustrationY+dy));
        moved=true;
      }else if(state.moveMode==='photo' && state.image){
        state.photoX+=dx;
        state.photoY+=dy;
        moved=true;
      }

      if(moved){
        markUnsaved();
        draw();
      }
    });

    function endDrag(){
      if(!moved && history.length) history.pop();
      dragging=false;
    }

    canvas.addEventListener('pointerup',endDrag);
    canvas.addEventListener('pointercancel',endDrag);

    form.addEventListener('submit',function(event){
      if(saved) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      setMessage('Sla eerst je ontwerp op met “Klaar met ontwerpen”.','is-error');
      openEditor();
    },true);

    if(addButton) addButton.disabled=true;
    draw();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();

  document.addEventListener('shopify:section:load',function(){setTimeout(init,0);});
})();

  } catch(e) { console.error(e); }
})();
})();
